export const StoreOrderStatus = {
  VALIDATION_PENDING: 'VALIDATION_PENDING',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  PAYMENT_DONE: 'PAYMENT_DONE',
  FLEX_SENDING: 'FLEX_SENDING',
  FLEX_ERROR: 'FLEX_ERROR',
  FLEX_RECEIVED: 'FLEX_RECEIVED',
  FLEX_ACCEPTED: 'FLEX_ACCEPTED',
  FLEX_STAGING: 'FLEX_STAGING',
  FLEX_PREPARING: 'FLEX_PREPARING',
  FLEX_READY: 'FLEX_READY',
  FLEX_DELIVERING: 'FLEX_DELIVERING',
  FLEX_DELIVERED: 'FLEX_DELIVERED',
  FLEX_CANCELLED: 'FLEX_CANCELLED',
  CANCELLED: 'CANCELLED',
  FINISHED: 'FINISHED',
  PICKUP_EXPIRED: 'PICKUP_EXPIRED',
} as const

export const StoreOrderSubstatus = {
  PAYMENT_PENDING_COUNTER: 'PAYMENT_PENDING_COUNTER',
  PAYMENT_DONE_MCDIA: 'PAYMENT_DONE_MCDIA',
  PAYMENT_DONE_MCDIA_3DAYS: 'PAYMENT_DONE_MCDIA_3DAYS',
  PAYMENT_DONE_MCDIA_INDATE: 'PAYMENT_DONE_MCDIA_INDATE',
  PAYMENT_DONE_MCDIA_EXPIRED: 'PAYMENT_DONE_MCDIA_EXPIRED',
  TOTAL_REFUNDED_MONEY: 'TOTAL_REFUNDED_MONEY',
  TOTAL_REFUNDED_LOYALTY: 'TOTAL_REFUNDED_LOYALTY',
  TOTAL_REFUNDED_ALL: 'TOTAL_REFUNDED_ALL',
  TOTAL_REFUNDED_VOUCHER: 'TOTAL_REFUNDED_VOUCHER',
  PARTIAL_REFUNDED_MONEY: 'PARTIAL_REFUNDED_MONEY',
  PARTIAL_REFUNDED_LOYALTY: 'PARTIAL_REFUNDED_LOYALTY',
  PARTIAL_REFUNDED_ALL: 'PARTIAL_REFUNDED_ALL',
  PARTIAL_REFUNDED_VOUCHER: 'PARTIAL_REFUNDED_VOUCHER',
} as const

export const StoreOrderRefundPartialSubStatus = {
  PARTIAL_REFUNDED_MONEY: 'PARTIAL_REFUNDED_MONEY',
  PARTIAL_REFUNDED_LOYALTY: 'PARTIAL_REFUNDED_LOYALTY',
  PARTIAL_REFUNDED_ALL: 'PARTIAL_REFUNDED_ALL',
  PARTIAL_REFUNDED_VOUCHER: 'PARTIAL_REFUNDED_VOUCHER',
} as const

export const StoreOrderRefundTotalSubStatus = {
  TOTAL_REFUNDED_MONEY: 'TOTAL_REFUNDED_MONEY',
  TOTAL_REFUNDED_LOYALTY: 'TOTAL_REFUNDED_LOYALTY',
  TOTAL_REFUNDED_ALL: 'TOTAL_REFUNDED_ALL',
  TOTAL_REFUNDED_VOUCHER: 'TOTAL_REFUNDED_VOUCHER',
} as const

export const StoreOrderRefundSubstatus = {
  ...StoreOrderRefundTotalSubStatus,
  ...StoreOrderRefundPartialSubStatus,
} as const

export const StoreOrderMcDiaSubstatus = {
  [StoreOrderSubstatus.PAYMENT_DONE_MCDIA]: StoreOrderSubstatus.PAYMENT_DONE_MCDIA,
  [StoreOrderSubstatus.PAYMENT_DONE_MCDIA_3DAYS]: StoreOrderSubstatus.PAYMENT_DONE_MCDIA_3DAYS,
  [StoreOrderSubstatus.PAYMENT_DONE_MCDIA_INDATE]: StoreOrderSubstatus.PAYMENT_DONE_MCDIA_INDATE,
  [StoreOrderSubstatus.PAYMENT_DONE_MCDIA_EXPIRED]: StoreOrderSubstatus.PAYMENT_DONE_MCDIA_EXPIRED,
}

export const ORDER_STATUS_VIEW = {
  IN_PROGRESS: 'IN_PROGRESS',
  FINISHED: 'FINISHED',
} as const

export type OrderStatusViewKey = keyof typeof ORDER_STATUS_VIEW

// OrderOngoingSteps
export type OrderStep = {
  key: string
  index: number
  filled: boolean
  completed: boolean
}

// useOrderDetail.mcDiaInfo
export type McDiaOrderInfo =
  | {
      isEvent: false
      showCard: false
      date: undefined
      onDate: undefined
      threeDaysBefore: undefined
      isExpired: undefined
      campaignName: undefined
    }
  | {
      isEvent: true
      showCard: boolean
      date: string
      onDate: boolean
      threeDaysBefore: boolean
      isExpired: boolean
      campaignName: string
    }
